import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../app/axios";


export const fetchRequiredCourses = createAsyncThunk(
  "requiredCourses/fetchRequiredCourses",
  async (studentId) => {
    const response = await axios.get("studentdashboard", {
      params: { studentId},
    });
    return response.data;
  },
);

const requiredCoursesSlice = createSlice({
  name: "requiredCourses",
  initialState: {
    courses: [],
    totals: { required: 0, earned: 0 },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRequiredCourses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRequiredCourses.fulfilled, (state, action) => {
        state.loading = false;
        state.courses = action.payload.records || [];
        state.totals = {
          required: 0,
          earned: action.payload.totalCreditsEarned ?? 0,
        };
      })
      .addCase(fetchRequiredCourses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default requiredCoursesSlice.reducer;
